import React from "react";

const StatCard = ({ icon, title, value, color }) => (
  <div className="bg-gray-900 border border-gray-700 rounded-xl p-4 flex items-center gap-4">
    <div className={`text-3xl ${color}`}>{icon}</div>

    <div>
      <div className="text-xs text-gray-400 uppercase">{title}</div>

      <div className="text-xl font-bold text-white">{value}</div>
    </div>
  </div>
);

export default function ScorePlusStatistics({ records = [] }) {
  if (!records.length) return null;

  const scores = records.map((r) => Number(r.score) || 0);

  const highestScore = Math.max(...scores);

  const lowestScore = Math.min(...scores);

  const longestSession = Math.max(
    ...records.map((r) => Number(r.duration) || 0),
  );

  const bestDayMap = {};

  records.forEach((r) => {
    if (!bestDayMap[r.date]) {
      bestDayMap[r.date] = {
        total: 0,
        count: 0,
      };
    }

    bestDayMap[r.date].total += Number(r.score) || 0;
    bestDayMap[r.date].count++;
  });

  let bestDay = "";
  let bestAverage = 0;

  Object.keys(bestDayMap).forEach((date) => {
    const avg = bestDayMap[date].total / bestDayMap[date].count;

    if (avg > bestAverage) {
      bestAverage = avg;
      bestDay = date;
    }
  });

  const sortedDates = [...new Set(records.map((r) => r.date))].sort();

  let streak = 0;

  for (let i = sortedDates.length - 1; i >= 0; i--) {
    const completed = records.filter(
      (r) => r.date === sortedDates[i] && r.status === "Done",
    ).length;

    if (completed > 0) {
      streak++;
    } else {
      break;
    }
  }

  const firstHalf = records.slice(0, Math.floor(records.length / 2));

  const secondHalf = records.slice(Math.floor(records.length / 2));

  const avg = (arr) =>
    arr.reduce((s, r) => s + (Number(r.score) || 0), 0) / arr.length;

  const improvement = (avg(secondHalf) - avg(firstHalf)).toFixed(1);

  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
      <StatCard
        icon="⭐"
        title="Highest Score"
        value={highestScore}
        color="text-yellow-400"
      />

      <StatCard
        icon="📉"
        title="Lowest Score"
        value={lowestScore}
        color="text-red-400"
      />

      <StatCard
        icon="🔥"
        title="Current Streak"
        value={`${streak} Days`}
        color="text-orange-400"
      />

      <StatCard
        icon="🏆"
        title="Best Day"
        value={bestDay}
        color="text-green-400"
      />

      <StatCard
        icon="⏱"
        title="Longest Session"
        value={`${longestSession} Min`}
        color="text-cyan-400"
      />

      <StatCard
        icon="📈"
        title="Improvement"
        value={`${improvement > 0 ? "+" : ""}${improvement}`}
        color={improvement >= 0 ? "text-green-400" : "text-red-400"}
      />
    </div>
  );
}
